import { Divider, Flex, Stack, Text } from '@mantine/core';
import { NotFound } from 'src/components/NotFound';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { SyncthingFolderDetails } from 'src/components/SyncthingFolderDetails';
import { ActionFooter } from 'src/components/ActionFooter';
import {
  ThemeGrid,
  InteractionDictionaryDetails,
} from 'src/features/interaction-dictionary/feature-interaction-dictionary-details';
import { useInteractionDictionaryDetails } from './use-interaction-dictionary-details';

export const InteractionDictionaryItem = () => {
  const {
    interactionDictionary,
    isPending,
    isError,
    handleDelete,
    handleCancel,
    themeOptions,
  } = useInteractionDictionaryDetails();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  if (isError || !interactionDictionary) {
    return <NotFound />;
  }

  return (
    <>
      <PageTitle title={interactionDictionary.name} />

      <Flex
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Stack gap="sm" mt="md">
          <InteractionDictionaryDetails
            interactionDictionary={interactionDictionary}
          />

          <Divider my="md" />

          {interactionDictionary.syncthing_folder && (
            <>
              <SyncthingFolderDetails
                syncthingFolder={interactionDictionary.syncthing_folder}
                title="Syncthing Folder"
              />
              <Divider my="md" />
            </>
          )}

          <Text fw={500} size="lg">
            Themes
          </Text>
          <ThemeGrid
            dictionaryId={interactionDictionary.id}
            options={themeOptions}
          />
        </Stack>
        <ActionFooter
          onDelete={handleDelete}
          onCancel={handleCancel}
          showSubmitButton={false}
        />
      </Flex>
    </>
  );
};
